import { useSelector } from "react-redux"
import { useLocation } from "react-router-dom"

import { RoutesPaths } from "../constants/user-routes"
import { useExternalDemoMode } from "./useExternalDemoMode"

const routesWithBanner = [
  RoutesPaths.home,
  RoutesPaths.dashboard.root,
  // Its drill-downs sit on their own prefix (see user-routes.js).
  RoutesPaths.dashboard.alerts_by_country,
  RoutesPaths.dashboard.alerts_by_bank,
  RoutesPaths.alerts.all,
  RoutesPaths.configure.root,
  RoutesPaths.credits,
  RoutesPaths.settings.team,
  RoutesPaths.health.root
]

export const useDemoBannerVisible = () => {
  const { pathname } = useLocation()
  const auth = useSelector((state) => state.auth)
  const externalDemoMode = useExternalDemoMode()
  const isAdmin = auth?.isAdmin

  if (isAdmin) return false

  if (!auth?.userInfo?.is_demo && !auth?.userInfo?.is_light_mode && !externalDemoMode) {
    return false
  }

  return routesWithBanner.some((route) => pathname.startsWith(route))
}

export default useDemoBannerVisible
